import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black py-8 text-center text-white">
      <div className="container mx-auto">
        Copyright &copy; M-Home. Developed By{" "}
        <a
          className="text-accent underline"
          href="https://mouaddev1.github.io/me/"
        >
          MouadDev1
        </a>
      </div>
    </footer>
  );
};

export default Footer;
